<template>
  <div>
    <common-title :title="type == 1 ? '创建会议' : '编辑会议'"></common-title>
    <div class="outdiv">
      <el-form
        :model="meetingForm"
        :rules="rules"
        ref="meetingForm"
        label-width="190px"
      >
        <el-form-item
            label="语言版本"
        >
          <el-radio v-model="meetingForm.languageType" :label="0">中文</el-radio>
          <el-radio v-model="meetingForm.languageType" :label="1">英文</el-radio>
          <el-radio v-model="meetingForm.languageType" :label="2">中文/英文</el-radio>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="会议标题"
          prop="meetingSubject"
        >
          <el-input
            v-model="meetingForm.meetingSubject"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="会议标题（英文）"
          prop="meetingSubjectEn"
        >
          <el-input
            v-model="meetingForm.meetingSubjectEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item label="主办单位" prop="organizer" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <el-input
            v-model="meetingForm.organizer"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="主办单位（英文）"
          prop="organizerEn"
        >
          <el-input
            v-model="meetingForm.organizerEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item label="承办单位" prop="undertaker" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <el-input
            v-model="meetingForm.undertaker"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
            v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="承办单位（英文）"
          prop="undertakerEn"
        >
          <el-input
            v-model="meetingForm.undertakerEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item label="举办地址" prop="address" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <el-input
            v-model="meetingForm.address"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="举办地址（英文）"
          prop="addressEn"
        >
          <el-input
            v-model="meetingForm.addressEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item label="会议时间" required>
          <el-col :span="8">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="meetingForm.startTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择开始时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">-</el-col>
          <el-col :span="8">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="meetingForm.endTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择结束时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            （排序使用）
          </el-col>
        </el-form-item>
        <el-form-item label="会议时间文本" prop="meetingStartTime" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <el-input
              v-model="meetingForm.meetingStartTime"
              :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="会议时间文本（英文）"
            prop="meetingTimeTextEn"
            v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <el-input
              v-model="meetingForm.meetingStartTimeEn"
              :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item label="投稿结束时间">
          <el-form-item>
            <el-date-picker
              v-model="meetingForm.contributionDeadline"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择投稿结束时间"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item label="投稿结束时间文本" prop="meetingContributionTime" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <el-input
              v-model="meetingForm.meetingContributionTime"
              :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="投稿结束时间文本（英文）"
            v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
            prop="meetingContributionTimeEn">
          <el-input
              v-model="meetingForm.meetingContributionTimeEn"
              :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="会议介绍"
          v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen"
          prop="meetingIntroduce"
        >
          <el-input
            type="textarea"
            v-model="meetingForm.meetingIntroduce"
            maxlength="5000"
            show-word-limit
            :rows="5"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="会议介绍（英文）"
          prop="meetingIntroduceEn"
        >
          <el-input
            type="textarea"
            v-model="meetingForm.meetingIntroduceEn"
            maxlength="5000"
            show-word-limit
            :rows="5"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.topic')" :key="Math.random()" prop="subjectSolicitation">
          <!-- <tag-component
            v-if="false"
            :tagArr="meetingForm.subjectSolicitation"
            @input="getMeetingSubjectSolicitation"
          ></tag-component> -->
          <tag-table-component :tagArr="meetingForm.subjectSolicitation" @input="getMeetingSubjectSolicitation"></tag-table-component>
        </el-form-item>

        <el-form-item :label="$t('common.DoubleCommit')">
          <el-radio v-model="meetingForm.doubleSubmissionOrNot" :label="1">是</el-radio>
          <el-radio v-model="meetingForm.doubleSubmissionOrNot" :label="0">否</el-radio>
          <double-commit-table-component v-if="meetingForm.doubleSubmissionOrNot==1" :arr="meetingForm.doubleCommitArr" @input="getMeetingDoubleCommitArr"></double-commit-table-component>
        </el-form-item>

        <el-form-item
          label="期刊支持"
          v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen"
          prop="journalSupport"
        >
          <el-input
            v-model="meetingForm.journalSupport"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="期刊支持（英文）"
          prop="journalSupportEn"
        >
          <el-input
            v-model="meetingForm.journalSupportEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="会议费用"
          v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen"
          prop="conferenceExpenses"
        >
          <el-input
            v-model="meetingForm.conferenceExpenses"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="会议费用（英文）"
          prop="conferenceExpensesEn"
        >
          <el-input
            v-model="meetingForm.conferenceExpensesEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="会议网站"
          v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen"
          prop="conferenceWebsite"
        >
          <el-input
            v-model="meetingForm.conferenceWebsite"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="会议网站（英文）"
          prop="conferenceWebsiteEn"
        >
          <el-input
            v-model="meetingForm.conferenceWebsiteEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式"
          prop="contactInformation"
          v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen"
        >
          <el-input
            v-model="meetingForm.contactInformation"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
            v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen"
          label="联系方式（英文）"
          prop="contactInformationEn"
        >
          <el-input
            v-model="meetingForm.contactInformationEn"
            :placeholder="$t('common.pleaseInput')"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="type == 1">
          <el-button @click="goBack()">{{ $t("common.cancelSpace") }}</el-button>
          <el-button type="primary" @click="submitForm('meetingForm')"
            >{{$t('common.trueText')}}</el-button
          >
        </el-form-item>
        <el-form-item v-if="type == 2">
          <el-button @click="goBack">{{ $t("common.cancelSpace") }}</el-button>
          <el-button type="primary" @click="submitForm('meetingForm')"
            >{{$t('common.trueText')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import commonTitle from "@/components/common/commonTitle";
import tagComponent from "@/components/meeting/tagComponent";
import tagTableComponent from "./tagTableComponent";
import typeToName from "@/utils/typeToName";
import doubleCommitTableComponent from "./doubleCommitTableComponent";
export default {
  data() {
    return {
      code: '',
      meetingForm: {
        languageType: 0, //语言版本 '0'中文，'1'英文,'2'中英文
        meetingSubject: "",
        meetingSubjectEn: '',
        organizer: '',
        subjectSolicitation: [],
        doubleSubmissionOrNot: 0,
        doubleCommitArr: [],
      },
    }
  },
  props: ["type"], //1：添加，2：编辑 3：详情
  components: {
    tagComponent,
    commonTitle,
    tagTableComponent,
    doubleCommitTableComponent,
  },
  created(){
    if (this.type==2) {
      this.code = this.$route.query.code;
      this.getMeetingDetail();
    }
  },
  filters:{
    yesNo(d){
      return typeToName.yesNo(d);
    }
  },
  computed:{
    currentMeetingCode(){
      return this.$store.state.dict.currentMeetingCode;
    },
    rules() {
      let rules = {
        meetingSubject: [
          { required: true, message: "请输入会议标题", trigger: "blur" },
          {
            min: 3,
            max: 300,
            message: this.$t('msg.enterLength2'),
            trigger: "blur",
          },
        ],
        organizer: [
          { required: true, message: "请输入主办单位", trigger: "blur" },
          {
            min: 3,
            max: 300,
            message: this.$t('msg.enterLength2'),
            trigger: "blur",
          },
        ],
        undertaker: [
          { required: true, message: "请输入承办单位", trigger: "blur" },
          {
            min: 3,
            max: 300,
            message: this.$t('msg.enterLength2'),
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入举办地址", trigger: "blur" },
          {
            min: 3,
            max: 300,
            message: this.$t('msg.enterLength2'),
            trigger: "blur",
          },
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        endTime: [
          // { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        meetingStartTime:[
          { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
        ],
        meetingContributionTime: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
        ],
        meetingIntroduce: [
          { required: true, message: "请填写会议介绍", trigger: "blur" },
        ],
        subjectSolicitation:[
          { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
        ],
      }
      if(this.meetingForm.languageType == this.LanguageTypeEnum.en){
        rules = {
          meetingSubjectEn: [
            { required: true, message: "请输入会议标题", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          organizerEn: [
            { required: true, message: "请输入主办单位", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          undertakerEn: [
            { required: true, message: "请输入承办单位", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          addressEn: [
            { required: true, message: "请输入举办地址", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          startTime: [
            { required: true, message: "请选择开始时间", trigger: "change" },
          ],
          endTime: [
            // { required: true, message: "请选择结束时间", trigger: "change" },
          ],
          meetingStartTimeEn:[
            { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
          ],
          meetingContributionTimeEn: [
            { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
          ],
          meetingIntroduceEn: [
            { required: true, message: "请填写会议介绍", trigger: "blur" },
          ],
        }
      }
      if(this.meetingForm.languageType == this.LanguageTypeEnum.zhen){
        rules = {
          meetingSubject: [
            { required: true, message: "请输入会议标题", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          meetingSubjectEn: [
            { required: true, message: "请输入会议标题", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          organizer: [
            { required: true, message: "请输入主办单位", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          organizerEn: [
            { required: true, message: "请输入主办单位", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          undertaker: [
            { required: true, message: "请输入承办单位", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          undertakerEn: [
            { required: true, message: "请输入承办单位", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          address: [
            { required: true, message: "请输入举办地址", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          addressEn: [
            { required: true, message: "请输入举办地址", trigger: "blur" },
            {
              min: 3,
              max: 300,
              message: this.$t('msg.enterLength2'),
              trigger: "blur",
            },
          ],
          startTime: [
            { required: true, message: "请选择开始时间", trigger: "change" },
          ],
          endTime: [
            // { required: true, message: "请选择结束时间", trigger: "change" },
          ],
          meetingStartTime:[
            { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
          ],
          meetingStartTimeEn:[
            { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
          ],
          meetingContributionTime: [
            { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
          ],
          meetingContributionTimeEn: [
            { required: true, message: this.$t('common.pleaseInput'), trigger: "blur" },
          ],
          meetingIntroduce: [
            { required: true, message: "请填写会议介绍", trigger: "blur" },
          ],
          meetingIntroduceEn: [
            { required: true, message: "请填写会议介绍", trigger: "blur" },
          ],
        }
      }
      return rules;
    },
  },
  watch:{
    currentMeetingCode(){
      this.code = this.currentMeetingCode;
      this.getMeetingDetail();
    },
  },
  methods: {
    goBack(){
      this.$router.back(-1)
    },
    // 征文主题标签
    getMeetingSubjectSolicitation(val) {
      // console.log(val);
      this.meetingForm.subjectSolicitation = val;
    },
    // 双重提交标签
    getMeetingDoubleCommitArr(val) {
      this.meetingForm.doubleCommitArr = val;
    },
    // 会议详情查询
    getMeetingDetail() {
      const data = {
        meetingCode: this.code,
      };
      this.$api.getMeetingDetail(data).then((res) => {
        if (res.code == 200) {
          this.meetingForm = res.data;
          this.meetingForm.subjectSolicitation = [];
          if(res.data.crSolicitcInfoEntityVoList){
            res.data.crSolicitcInfoEntityVoList.some(x=>{
              this.meetingForm.subjectSolicitation.push(x.solicitcName)
            })
          }
          this.meetingForm.doubleCommitArr = [];
          if(res.data.crSubmissionEntityList){
            res.data.crSubmissionEntityList.some(x=>{
              this.meetingForm.doubleCommitArr.push(x.doubleSubmissionComment)
            })
          }
        }
      });
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if(that.meetingForm.endTime){
          if(new Date(that.meetingForm.endTime) < new Date(that.meetingForm.startTime)){
            that.$message.error('结束时间需要大于开始时间')
            return;
          }
        }

        if (valid) {
          if (this.type == 1) {
            this.addMeeting();
          } else {
            this.editMeeting();
          }
        }
      });
    },
    addMeeting() {
      let data = JSON.parse(JSON.stringify(this.meetingForm))
      data.subjectSolicitation = [];
      this.meetingForm.subjectSolicitation.forEach(function(val){
          let obj = {};
          obj.solicitcName = val;
          data.subjectSolicitation.push(obj)
      })
      data.crSubmissionEntityList=[];
      this.meetingForm.doubleCommitArr.forEach(function(val){
        let obj = {};
        obj.doubleSubmissionComment = val;
        data.crSubmissionEntityList.push(obj)
      })
      this.$api.addMeeting(data).then((res) => {
        if(res.code == 200){
          this.$router.push({
            name:'meetManager'
          });
        }
      });
    },
    editMeeting() {
      let data = JSON.parse(JSON.stringify(this.meetingForm))
      // console.log('this.meetingForm.subjectSolicitation',this.meetingForm.subjectSolicitation)
      data.subjectSolicitation = [];
      this.meetingForm.subjectSolicitation.forEach(function(val){
        let obj = {};
        obj.solicitcName = val;
        data.subjectSolicitation.push(obj)
      })
      data.crSubmissionEntityList=[];
      if(this.meetingForm.doubleCommitArr.length>0){
        this.meetingForm.doubleCommitArr.forEach(function(val){
          let obj = {};
          obj.doubleSubmissionComment = val;
          data.crSubmissionEntityList.push(obj)
        })
      }
      this.$api.editMeeting(data).then((res) => {
        if(res.code == 200){
          this.$router.push({
            name:'meetManager'
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.outdiv {
  width: 800px;
}
</style>
